<template>
    <div class="float-left">
        <i
            class="fa fa-pencil-square-o fa-lg icon-button"
            title="Dados da Despesa"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalPrestacaoFinal"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Dados da Despesa
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasMensal">Prestação Mensal</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoMensal.idPrestacaoContasMensal"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtCompetencia">Competência</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoMensal.dtCompetencia"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtPrestacao">Data Prestação</label>
                            <b-input-group>
                                <b-form-input
                                    id="dtPrestacao"
                                    type="text"
                                    v-model="prestacaoMensal.dtPrestacao"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalGasto">Total Despesas</label>
                            <b-input-group>
                                <money
                                    id="nuTotalGasto"
                                    v-model="prestacaoMensal.nuTotalGasto"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Total Despesas é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalRendimentos">Total Rendimentos</label>
                            <b-input-group>
                                <money
                                    id="nuTotalRendimentos"
                                    v-model="prestacaoMensal.nuTotalRendimentos"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Total Rendimentos é obrigatório</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuReceitasDiversas">Receitas Diversas</label>
                            <b-input-group>
                                <money
                                    id="nuReceitasDiversas"
                                    v-model="prestacaoMensal.nuReceitasDiversas"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Receitas Diversas é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5">
                                    Lançamentos
                                </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="tblPrestacaoFinal"
                                    :itens="prestacoesFinais"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false"
                                >
                                    <template slot="botoes">
                                        <b-button-group class="float-right" v-if="$temAcesso('GESCON-FORN-CONV-07')">
                                            <cad-dados-despesas
                                                :convenio="convenio"
                                                :idPrestacaoMensal="idPrestacaoMensal"
                                                class="mr-2"
                                                @atualizarLista="obterPrestacaoMensal()"
                                            >
                                            </cad-dados-despesas>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span class="text-danger float-left mr-1" v-if="$temAcesso('GESCON-FORN-CONV-08')">
                                            <i
                                                class="fa fa-trash fa-lg icon-button"
                                                title="Excluir Recurso"
                                                @click.stop="excluir(data.idPrestacaoContasFinal)"
                                                v-if="data.codSituacao == 0 && convenio.idSituacaoConvenio != 9"
                                            ></i>
                                        </span>
                                        <span class="text-primary float-left mr-1" v-if="$temAcesso('GESCON-FORN-CONV-09')">
                                            <documentos
                                                :convenio="convenio"
                                                :prestacaoFinal="data"
                                                class="mr-2"
                                            >
                                            </documentos>
                                        </span>
                                    </template>
                                    <template slot="acao" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.acaoConvenio != null ? data.acaoConvenio.descricao : 'Não Informado' }}
                                        </p>
                                    </template>
                                    <template slot="nuValor" slot-scope="data">
                                        <p class="text-right m-0">
                                            {{ data.nuValor | currency }}
                                        </p>
                                    </template>
                                    <template slot="dtEmissao" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.dtEmissao ? $moment(data.dtEmissao).format('DD/MM/YYYY') : '' }}
                                        </p>
                                    </template>
                                    <template slot="dtPagamento" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.dtEmissao ? $moment(data.dtPagamento).format('DD/MM/YYYY') : '' }}
                                        </p>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import ConveniosServicos from '../ConvenioServicos'
    import CadDadosDespesas from '../cadastros/CadDadosDespesas.vue'
    import Documentos from './ConvenioDadosDespesaDocumentos.vue'

    export default {
        props: {
            convenio: {
                type: Object,
                default: () => ({})
            },
            idPrestacaoMensal: {
                type: Number,
                default: 0
            }
        },

        components: {
            CadDadosDespesas,
            Documentos,
        },

        data() {
            return {
                mostrarModal: false,
                itensPorPagina: 5,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                erros: [],
                prestacaoMensal: {},
                prestacoesFinais: [],
                campos: [
                    {
                        key: 'tipoPrestacaoContas',
                        label: 'Tipo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acao',
                        label: 'Ação',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'naturezaDespesa.descricaoCompleta',
                        label: 'Natureza',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'dtEmissao',
                        label: 'Emissão',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcFavorecido',
                        label: 'Favorecido',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcDocumento',
                        label: 'Documento',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nuValor',
                        label: 'Valor',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'dtPagamento',
                        label: 'Pagamento',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'situacao',
                        label: 'Situação',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ],
            }
        },

        methods: {
            abrirModal() {
                this.mostrarModal = true;
                this.obterPrestacaoMensal();
            },

            fecharModal() {
                this.mostrarModal = false;
                this.$emit('atualizarLista');
            },

            obterPrestacaoMensal(){
                if (this.idPrestacaoMensal > 0){
                    this.$store.dispatch('addRequest')
                    ConveniosServicos.ObterPrestacaoMensal(this.idPrestacaoMensal).then(
                        response => {
                            if (response) {
                                if (response.success) {
                                    this.prestacaoMensal = response.data
                                    this.prestacaoMensal.dtCompetencia = this.$moment(this.prestacaoMensal.dtCompetencia, 'YYYY-MM-DD').format('MM/YYYY')
                                    this.prestacaoMensal.dtPrestacao = this.$moment(this.prestacaoMensal.dtPrestacao, 'YYYY-MM-DD').format('DD/MM/YYYY')
                                    this.prestacoesFinais = response.data.prestacoesContasFinal;

                                    console.log(response.data)
                                } else {
                                    this.erros = response.errors
                                }
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
                }
            },

            excluir(id){
                this.$store.dispatch('addRequest')
                ConveniosServicos.ExcluirPrestacaoFinal(id)
                .then(
                    response => {
                        if (response) {
                            this.obterPrestacaoMensal();
                        }
                    }
                )
                this.$store.dispatch('removeRequest')
            },
        }
    }
</script>
